var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"thumbnail",style:({'background-image': _vm.backgroundUrl})},[(_vm.closeout)?_c('div',{staticClass:"closeout"},[_vm._v("CLOSEOUT")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }